import { render } from "./SheetOverlay.vue?vue&type=template&id=12b5c0b7&ts=true"
import script from "./SheetOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetOverlay.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sheet/SheetOverlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12b5c0b7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12b5c0b7', __exports__)) {
    api.reload('12b5c0b7', __exports__)
  }
  
  module.hot.accept("./SheetOverlay.vue?vue&type=template&id=12b5c0b7&ts=true", () => {
    api.rerender('12b5c0b7', render)
  })

}


export default __exports__